<div class="row">
    <div class="col-xl-9 col-md-12">
        <div id="userList" class="card">
            <ng-container *ngTemplateOutlet="pickList"></ng-container>
        </div>
    </div>
    <div class="col-xl-3 padding-top">
        <ng-container *ngTemplateOutlet="profileView"></ng-container>
    </div>
</div>


<ng-template #profileView>
    <div class="card" id="user-view-detail">

        <div class="card-body p-3 ">
            <div class="text-end">
                <button [disabled]="(model.id == undefined)" class="btn badge bg-light text-primary fs-12 "
                    (click)="
                    openModalService.editUserModal(model.id!, currentTenantId, userListService)
                    ">
                    <div class="d-inline-flex">
                        <i class="ri-edit-box-line align-bottom me-1"></i>
                        <div class="text-center" i18n="@@">Edit</div>
                    </div>
                </button>
            </div>

            <div class="text-center">

                <div class="profile-user position-relative d-inline-block mx-auto">
                    <div class="position-relative d-inline-block">

                        <img [src]="profilePhotoPNGTransform(model)" alt=""
                            class="avatar-lg rounded-circle img-thumbnail">
                        <span class="contact-active position-absolute rounded-circle bg-success"></span><span
                            class="visually-hidden"></span>
                    </div>
                    <h5 class="mt-4 mb-1" i18n="@@">{{model.name || "Not Provided"}}</h5>
                    <p class="text-muted" i18n="@@">{{model.companyName || "Not Provided"}}</p>
                </div>
            </div>
        </div>
        <div class=lineSplitter></div>

        <div class="card-body">
            <div class="mb-3">
                <h6 class="text-muted text-uppercase fw-semibold mb-3 " i18n="@@">user Information</h6>
                <div class="table-responsive table-card">
                    <table class="table table-borderless mb-0">
                        <tbody>
                            <tr>
                                <td class="fw-medium gap-2 " scope="row" i18n="@@"><i
                                        class="bg-soft-warning text-warning rounded bx bx-buildings p-1"></i> Company:
                                </td>
                                <td class="l_score" i18n="@@">{{model.companyName || "Not Provided"}}</td>

                            <tr>
                                <td class="fw-medium gap-2 " scope="row" i18n="@@"><i
                                        class="bg-soft-warning text-warning rounded bx bx-body p-1"></i> Occupation:
                                </td>
                                <td class="l_score" i18n="@@">{{model.occupation || "Not Provided"}}</td>
                            </tr>
                            <tr>
                                <td class="fw-medium gap-2 " scope="row" i18n="@@"><i
                                        class="bg-soft-danger text-danger rounded bx bx-mail-send p-1"></i> Email </td>
                                <td class="phone" i18n="@@">{{model.email || "Not Provided"}}</td>
                            </tr>
                            <tr>
                                <td class="fw-medium gap-2 " scope="row" i18n="@@"><i
                                        class="bg-soft-success text-success rounded bx bx bx-phone p-1"></i> Phone No
                                </td>
                                <td class="email" i18n="@@">{{model.phoneNumber || "Not Provided"}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <ul ngbNav #customNav="ngbNav" [activeId]="1"
                class="nav nav-tabs-custom rounded card-header-tabs border-bottom-0center justify-content-center"
                role="tablist">


                <li [ngbNavItem]="1" class="nav-item">
                    <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                        <i class="far fa-user"></i>
                        Status
                    </a>
                    <ng-template ngbNavContent>
                        <table class="table table-borderless mb-0">
                            <tbody style="text-transform: capitalize;">
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Status</td>
                                    <td class="designation" i18n="@@">{{statusText(model.status!) || "Not Provided"}}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Email Verified</td>
                                    <td class="designation" i18n="@@">
                                        <span *ngIf="(model.isEmailVerified == false) else elseNotVerified">
                                            {{model.isEmailVerified}}
                                        </span>
                                        <ng-template #elseNotVerified>
                                            {{model.isEmailVerified || "Not Provided"}}
                                        </ng-template>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Enabled</td>
                                    <td class="designation" i18n="@@">
                                        <span *ngIf="(model.enabled == false) else elseNotEnabled">
                                            {{model.enabled}}
                                        </span>
                                        <ng-template #elseNotEnabled>
                                            {{model.enabled || "Not Provided"}}
                                        </ng-template>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fw-medium gap-2 " scope="row" i18n="@@"> Created Date</td>
                                    <td class="email" i18n="@@">
                                        <span *ngIf="(model.createdDate) else elseNoCreatedDate">
                                            {{dateRename(model.createdDate!)}}
                                        </span>
                                        <ng-template #elseNoCreatedDate>
                                            Not Provided
                                        </ng-template>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fw-medium gap-2 " scope="row" i18n="@@"> Last Seen</td>
                                    <td class="email" i18n="@@">
                                        <span *ngIf="(model.lastActive) else elseNoLastActive">
                                            {{model.lastActive | amTimeAgo:true}} ago
                                        </span>
                                        <ng-template #elseNoLastActive>
                                            Not Provided
                                        </ng-template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </ng-template>
                </li>
                <li [ngbNavItem]="2" class="nav-item">
                    <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                        <i class="far fa-user"></i>
                        Address Information
                    </a>
                    <ng-template ngbNavContent>
                        <table class="table table-borderless mb-0">
                            <tbody>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Unit</td>
                                    <td class="designation" i18n="@@">{{model.address.unit || "Not Provided"}}</td>
                                </tr>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Street</td>
                                    <td class="email" i18n="@@">{{model.address.address1 || "Not Provided"}}</td>
                                </tr>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">City</td>
                                    <td class="phone" i18n="@@">{{model.address.city || "Not Provided"}}</td>
                                </tr>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Province</td>
                                    <td class="l_score" i18n="@@">{{model.address.province || "Not Provided"}}</td>
                                </tr>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Country</td>
                                    <td class="l_score" i18n="@@">{{model.address.country || "Not Provided"}}</td>
                                </tr>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Postal Code</td>
                                    <td class="l_score" i18n="@@">{{model.address.postalCode || "Not Provided"}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </ng-template>
                </li>
                <li [ngbNavItem]="3" class="nav-item">
                    <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                        <i class="far fa-user"></i>
                        Signature
                    </a>
                    <ng-template ngbNavContent>
                        <div class="col-lg-12 p-2">
                            <div class="border shadow text-center bg-white">
                                <img [src]="signaturePNGTransform()" class="p-2 signatureCanvas" />
                            </div>
                        </div>
                    </ng-template>
                </li>
            </ul>
            <div class="tab-content pt-4">
                <div [ngbNavOutlet]="customNav"></div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #pickList>
    <app-list-layout [tableConfig]="tableConfig" [listItems]="listItems" [listService]="userListService"
        [sortBy]="sortBy" (buttonActionSelected)="buttonActionSelected($event)"
        (updateCheckedValues)="checkedValGet =  $event" (rowActionSelected)="rowActionSelected($event)"
        (filterSelected)="filterSelected($event)" (sortSelected)="sortByPassedSort($event)"
        (searchTermChanged)="userListService.searchTerm = $event"
        (resetListLayout) = "userListService.resetListState($event)"
        (paginationSelected)="paginationUpdated(userListService,$event)" [serviceData]="serviceData"
        (pageSizeSelected)="userListService.pageSize = $event"></app-list-layout>
</ng-template>